import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { translate } from "react-i18next";
import { MenuItem } from "@material-ui/core";
import socialType from "../../utils/socialType";
import InputFormat from "../inputForm";
import { styles } from "./styles";
class SocialType extends Component {
  render() {
    const {
      classes,
      t,
      SelectProps = {},
      InputLabelProps = {},
      ...props
    } = this.props;
    return (
      <InputFormat
        {...props}
        select
        SelectProps={{
          displayEmpty: true,
          ...SelectProps
        }}
        InputLabelProps={{
          ...InputLabelProps,
          shrink: true
        }}
      >
        <MenuItem value="">{t("pls_select")}</MenuItem>
        {socialType.map((type, index) => (
          <MenuItem key={index} value={type.value}>
            {t(type.name)}
          </MenuItem>
        ))}
      </InputFormat>
    );
  }
}

SocialType.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired
};

export default translate("translations")(
  withStyles(styles, { withTheme: true })(SocialType)
);
